/**
 * 富文本图片懒加载
 * @param selector - CSS选择器，用于查找包含图片的容器，默认为 '.introduction_exh'
 * @param rootMargin - 提前加载的距离，默认为 '100px'
 */
import xss from 'xss'
export const lazyLoadHtmlImages = (selector: string = '.introduction_exh', rootMargin: string = '100px') => {
    if (!import.meta.client) return

    // 尝试不同的选择器
    let imgs = document.querySelectorAll(`${selector} img[data-src]`)

    // 如果找不到，尝试更宽泛的选择器
    if (imgs.length === 0) {
        imgs = document.querySelectorAll('img[data-src]')
    }

    if (imgs.length === 0) {
        return
    }

    if (!('IntersectionObserver' in window)) {
        // 兼容不支持的浏览器，直接加载
        imgs.forEach(img => {
            const dataSrc = img.getAttribute('data-src')
            if (dataSrc && !(img as HTMLImageElement).src) {
                ; (img as HTMLImageElement).src = dataSrc
                img.removeAttribute('data-src')
            }
        })
        return
    }

    const observer = new IntersectionObserver(
        (entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const img = entry.target as HTMLImageElement
                    const dataSrc = img.getAttribute('data-src')
                    if (dataSrc && !img.src) {
                        img.src = dataSrc
                        img.removeAttribute('data-src')
                    }
                    observer.unobserve(img)
                }
            })
        },
        { rootMargin }
    )

    imgs.forEach(img => {
        observer.observe(img)
    })
}
/**
 * 处理资讯内容
 * 资讯的图片src属性改为data-src(懒加载需要)
 * 如果图片域名包含jufair.com, 给图片后缀加!swebp(图片压缩)
 *
 * */
export const handleNewDetail = (data: string) => {
    if(!data){
        return data
    }
    let result = data
        .replace(/src=/gi, 'data-src=')
        .replace(/(<img.*?data-src=")(.*?)(".*?>)/gi, function (a, b, c, d) {
            //a是整体
            //b是第一个分组  <img data-src="
            //c是第二个分组  图片url
            //d是第三个分组  ">
            // 增加图片压缩后缀 !swebp
            if (c.includes('jufair.com') && !c.includes('!swebp')) {
                return `${b}${c}!swebp${d}`
            }
            return a
        })
    return result
}
const defaultWhite = xss.getDefaultWhiteList()
defaultWhite.img = [
    "src", "alt", "title", "width", "height", "loading", // 允许常规属性
    'data-src',        // 关键：允许 data-src 属性用于懒加载
]

export const xssOptions = {
    whiteList: {
        ...defaultWhite
    }
}
